import script from "./AppHorizontalScrolling.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHorizontalScrolling.vue?vue&type=script&setup=true&lang=js"

import "./AppHorizontalScrolling.vue?vue&type=style&index=0&id=3a351862&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a351862"]])

export default __exports__